import styles from '@containers/Profiles/EditProfile/EditProfile.module.css';

const RegionSpecificDocumentInfo = ({
  documentName,
  countrySpecific,
  areaSpecific,
}) => {
  if (!countrySpecific && !areaSpecific) {
    return <>{documentName} can be Worldwide.</>;
  }
  return (
    <>
      {documentName} needs to be{' '}
      <span className={styles.textRed}>
        {areaSpecific ? 'Area' : 'Country'}
      </span>{' '}
      specific.
    </>
  );
};

export const EditProfileInfo = ({
  addressDocument,
  companyRegistrationDocument,
}) => (
  <div className={styles.editProfileInfo}>
    <p>
      <RegionSpecificDocumentInfo
        documentName="Address"
        countrySpecific={addressDocument.country_specific}
        areaSpecific={addressDocument.area_specific}
      />{' '}
      <RegionSpecificDocumentInfo
        documentName="Company registration"
        countrySpecific={companyRegistrationDocument.country_specific}
        areaSpecific={companyRegistrationDocument.area_specific}
      />
    </p>
    <p>
      Please note that all data, even when entered as optional, needs to be
      correct.
    </p>
    <p>
      Newly submitted data and documents are normally validated within 1
      business day.
    </p>
    <p>Incorrect data can lead to incomplete or delayed orders.</p>
    <p>
      If you want to see a list of DID’s connected to a certain End user you can
      access that via the My Numbers menu
    </p>
  </div>
);
